export const formConfigC = [
  {
    key: 'ComName',
    Name: '公司',
    EName: 'Organization',
    Holder: '请输入公司',
    EHolder: 'Please enter your Organization',
    IsMust: true,
    EIsMust: true,
    IsShow: true,
    EisShow: true,
    Sort: 4,
    Options: null,
    EOptions: null
  },
  {
    key: 'Rank',
    Name: '职务',
    EName: 'Job Title',
    Holder: '请输入您的职务',
    EHolder: 'Please enter your Job Title',
    IsMust: true,
    EIsMust: true,
    IsShow: true,
    EisShow: true,
    Sort: 5,
    Options: null,
    EOptions: null
  },
  {
    key: 'Name',
    Name: '姓名',
    EName: 'Full Name',
    Holder: '请输入您的姓名',
    EHolder: 'Please enter your name',
    IsMust: true,
    EIsMust: true,
    IsShow: true,
    EisShow: true,
    Sort: 1,
    Options: null,
    EOptions: null
  },
  {
    key: 'Mobile',
    Name: '手机',
    EName: 'mobile',
    Holder: '请输入您的手机',
    EHolder: 'Please enter your mobile',
    IsMust: true,
    EIsMust: true,
    IsShow: true,
    EisShow: true,
    Sort: 9,
    Options: null,
    EOptions: null
  },
  {
    key: 'Email',
    Name: '邮箱',
    EName: 'email',
    Holder: '请输入您的邮箱',
    EHolder: 'Please enter your email',
    IsMust: true,
    EIsMust: true,
    IsShow: true,
    EisShow: true,
    Sort: 6,
    Options: null,
    EOptions: null
  }
]

export const quesConfigC = [
  {
    Question_QusType: 'M',
    QuestionsID: 198,
    QuestionsQusETitle: 'Type of Cooperation (Multiple Selection Allowed)',
    QuestionsQusTitle: '合作类型（可多选）',
    Questions_IsRequired: true,
    Questions_MaxAnsCount: null,
    Questions_MinAnsCount: null,
    Questions_Sort: 1,
    checked: [],
    AnswersCollect: [
      {
        AnswersEInputText: null,
        AnswersETitle: 'Apply for Side Event',
        AnswersID: 2387,
        AnswersInputText: null,
        AnswersIsInput: false,
        AnswersSort: 1,
        AnswersTitle: '申请边会',
        Answers_IsCN: true,
        Answers_IsEN: false,
        ChildAnswers: null,
        otherCon: ''
      },
      {
        AnswersEInputText: null,
        AnswersETitle: 'Become a Sponsor',
        AnswersID: 2388,
        AnswersInputText: null,
        AnswersIsInput: false,
        AnswersSort: 2,
        AnswersTitle: '赞助合作',
        Answers_IsCN: true,
        Answers_IsEN: false,
        ChildAnswers: null,
        otherCon: ''
      }
    ]
  }
]
